var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1731_1679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1731_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19976 9.32668L2.67285 8.79976L5.47285 5.99976L2.67285 3.19976L3.19976 2.67285L5.99976 5.47285L8.79976 2.67285L9.32668 3.19976L6.52668 5.99976L9.32668 8.79976L8.79976 9.32668L5.99976 6.52668L3.19976 9.32668Z",
    fill: "#2C93D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlue);
export default __webpack_public_path__ + "static/media/close_icon_blue.a2f6d25b8f7493fb8625e566882ed5e5.svg";
export { ForwardRef as ReactComponent };